const folder = '/images/maps/pins';

const images = [
    {
        key: 'default',
        src: `${folder}/default.png`
    },
    {
        key: 'slap',
        src: `${folder}/slap.png`
    },
    {
        key: 'hrib',
        src: `${folder}/hrib.png`
    },
    {
        key: 'planina',
        src: `${folder}/planina.png`
    },
    {
        key: 'jezero',
        src: `${folder}/jezero.png`
    },
    {
        key: 'bivak',
        src: `${folder}/bivak.png`
    },
    {
        key: 'cerkev',
        src: `${folder}/cerkev.png`
    },
    {
        key: 'dvorec',
        src: `${folder}/dvorec.png`
    },
    {
        key: 'ferata',
        src: `${folder}/ferata.png`
    },
    {
        key: 'grad',
        src: `${folder}/grad.png`
    },
    {
        key: 'izvir',
        src: `${folder}/izvir.png`
    },
    {
        key: 'jama',
        src: `${folder}/jama.png`
    },
    {
        key: 'koca',
        src: `${folder}/koca.png`
    },
    {
        key: 'kopalisce',
        src: `${folder}/kopalisce.png`
    },
    {
        key: 'muzej-na-prostem',
        src: `${folder}/muzej_na_prostem.png`
    },
    {
        key: 'park',
        src: `${folder}/park.png`
    },
    {
        key: 'razgledni-stolp',
        src: `${folder}/razgledni_stolp.png`
    },
    {
        key: 'soteska',
        src: `${folder}/soteska.png`
    },
    {
        key: 'sup-tocka',
        src: `${folder}/sup_tocka.png`
    }
];

export default images;
